<template>
    <div>

        <vue-headful title="Clients :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-address-book-o"></i> Clients</li>
                <li class="ml-3">
                    <router-link :to="`/clients/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create Client</router-link>
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <client-list />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },
    }
</script>
